import { useParams } from 'react-router-dom'

import { TrainingsMembershipsLiteDocument } from 'generated/resources/graphql'

import Loading from 'modules/core/components/Loading'
import { useQuery } from 'modules/core/hooks/useQuery'

import { AddParticipantsModal } from 'modules/trainings/components/Revamp/TrainingsDetail/TrainingEmployeesDataTable/AddParticipantsModal'

const AddParticipants = () => {
  const { id } = useParams()
  const { data, loading } = useQuery(TrainingsMembershipsLiteDocument, {
    variables: { trainingId: Number(id) },
  })

  if (loading) return <Loading />

  const employeeIds =
    data?.trainings?.trainingMemberships.map((m) => m.access?.employee?.id).filter(Boolean) ?? []

  return <AddParticipantsModal employeeIds={employeeIds} />
}

export default AddParticipants
